module.exports = __webpack_public_path__ + "static/Trevor_Pugh_headshot_lores-63f4c0411a580c985cd4a0f7ca77c589.png";